module.exports = __webpack_public_path__ + "img/app-icon.6f373cfa.jpg";